module.exports = __webpack_public_path__ + "static/media/hall_entree.9ee4c83d.jpg";